// extracted by mini-css-extract-plugin
module.exports = {"drawerBody":"index_drawerBody__145CB"};